import { TextInput, Label } from "flowbite-react";

function InputComponent(props) {
  const {
    type = "text",
    id,
    placeholder = "",
    required = false,
    className = "",
    error,
  } = props;
  return (
    <div>
      {props?.label && <Label className="text-app-secondary">{props.label}</Label>}
      <TextInput
        {...props}
        type={type}
        id={id}
        placeholder={placeholder}
        required={required}
        className={`${className} block w-full border border-app-primary rounded-lg ring-app-primary focus:border-app-primary bg-app-input text-app-primary placeholder-app-muted`}
      />
      {error && <p className="text-app-error text-sm mt-1">{error}</p>}
    </div>
  );
}
export default InputComponent;
